module.exports = __webpack_public_path__ + "img/SCVN.d8160207.png";